<template>
  <b-modal
    v-model="modal.modal"
    :title="title"
    header-class="approval-modal__header"
    centered
    hide-footer
    no-enforce-focus
  >
    <ValidationObserver ref="form">
      <div class="container">
        <div class="row">
          <b-form @submit.prevent>
            <div md="12" class="mb-3">
              <AGCLabel required>匯款日期</AGCLabel>
                <br />
              <AGCDateTimePicker
                v-model="inputVal.transferDate"
                rules="required"
                name="匯款日期"
                class="custom-date mr-3"
                style="display:block;"
              ></AGCDateTimePicker>
            </div>
            <AGCInput
              v-model.trim="inputVal.others"
              name="其他費用"
              rules="max:10"
              class="mb-3"
              placeholder="其他費用"
              label="其他費用"
              autofocus
            ></AGCInput>
            <DropZone
              v-model="inputVal.statement"
              rules="required"
              name="月結單"
              class="mb-3 dropbox"
              upload-type="statement"
              :acceptedFiles="'.pdf'"
              label="月結單"
              id="pdf"
              sub-label="(最多1個PDF, 每個上限2mb)"
              required
            ></DropZone>
            <ContentEditor
              v-model="inputVal.remarks"
              name="備註"
              label="備註"
              class="mb-3"
              :toolbar="toolbarValue"
            ></ContentEditor>
          </b-form>
        </div>
        <div class="row">
          <div class="col-12">
            <b-button variant="outline-secondary" :disabled="loading" @click="modal.modal = false">
              取消
            </b-button>
            <b-button
              variant="success"
              v-stream:click="onWithdrawApprove"
              :disabled="loading"
            >
              <span>確定</span>
            </b-button>
          </div>
        </div>
      </div>
    </ValidationObserver>
    <LoadingSpinner v-show="loading"></LoadingSpinner>
  </b-modal>
</template>

<script>
import { BButton, BModal, BForm } from 'bootstrap-vue';
import { Subject } from 'rxjs';
import formMixin from '@/mixins/form';
import AGCLabel from '@/components/form/AGCLabel.vue';
import AGCInput from '@/components/form/AGCInput.vue';
import AGCDateTimePicker from '@/components/form/AGCDateTimePicker.vue';
import DropZone from '@/components/form/DropZone.vue';
import ContentEditor from '@/components/editor/ContentEditor.vue';
import LoadingSpinner from '@/components/LoadingSpinner.vue';
import vModelMixin from '../../mixins/v-model';

export default {
  mixins: [vModelMixin, formMixin],
  props: {
    loading: {
      type: Boolean,
    },
    onWithdrawApprove: {
      type: Subject,
    },
    modal: {
      type: Object,
    },
    readOnly: {
      type: Boolean,
    },
  },
  data: () => ({
    init: {
      quickbars_insert_toolbar: false,
      height: '250',
    },
    toolbarValue: [`
      undo redo |
      bold italic underline |
      alignleft aligncenter alignright alignjustify |
      bullist numlist outdent indent |
      link |
    `],
  }),
  components: {
    BButton,
    BModal,
    BForm,
    AGCLabel,
    AGCInput,
    AGCDateTimePicker,
    ContentEditor,
    DropZone,
    LoadingSpinner,
  },
  computed: {
    title() {
      return '確定已匯款';
    },
  },
};
</script>

<style lang="scss" scoped>
::v-deep {
  .modal {
    &-dialog {
      max-width: 600px;
    }

    &-header {
      padding: 24px;
      border: none;
    }

    &-title {
      margin: 0 auto;
      font-size: 18px;
      font-weight: 400;
      color: #3a4047;
    }

    &-header .close {
      margin-left: -52px;
      margin-top: -12px;
      font-size: 20px;
    }

    &-body {
      padding: 0 24px 24px 24px;
    }

    &-body .col-12 {
      padding: 0;
      text-align: right;
    }

    .btn {
      margin-top: 24px;
      margin-left: 12px;
      width: 115px;
      padding: 10px 16px;

      &-success {
        background-color: #36b674 !important;
        border-color: #36b674 !important;
      }

      &-outline-secondary {
        background-color: #f9f9fa !important;
        border: 1px solid #dde1e5 !important;

        &:hover {
          background-color: #636d77 !important;
          border: 1px solid #636d77 !important;
        }
      }
    }

    .dropbox{
      .btn{
        margin:0px;
        width:auto;
        padding:0px;
      }
    }
  }
}
</style>
